import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BIDS_DELETE_URL, PRODUCT_DETAILS_URL } from "../../utils/Constant";
import { useSelector } from "react-redux";
import axios from "axios";
import CountdownTimer from "./CountdownTimer";
import { convertIsoToCustomFormat } from "../../utils/Helper";

const ProductBidHistory = () => {
  const { productId } = useParams();
  const [bidHistory, setBidHistory] = useState();
  const [currentBidItem, setCurrentBidItem] = useState(null);
  const [isBidDeleted, setIsBidDeleted] = useState(false);
  const [orderIdToDelete, setOrderIdToDelete] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const authToken = useSelector((state) => state.token);
  const navigate = useNavigate();

  const fetchBids = async () => {
    try {
      if (productId) {
      }
      const response = await fetch(`${PRODUCT_DETAILS_URL}/${productId}`, {
        headers: {
          Authorization: `Bearer ${authToken.token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setBidHistory(data.data);
    } catch (error) {}
  };

  useEffect(() => {
    if (authToken) {
      fetchBids();
    } else {
      navigate("/login");
    }
  }, [productId]);

  const handleConfirmDelete = async (e) => {
    e.preventDefault();
    try {
      await axios
        .delete(`${BIDS_DELETE_URL}/${orderIdToDelete}`, {
          headers: {
            Authorization: `Bearer ${authToken.token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            setIsBidDeleted(true);
            setTimeout(() => {
              setIsBidDeleted(false);
              handleCloseModal();
              fetchBids();
            }, 1000);
          } else {
            console.error("Deletion failed. Status code:", response.status);
          }
        })
        .catch((error) => {
          console.error("Error deleting product:", error);
        });
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };
  const Modal = ({ isOpen, onClose, onDelete }) => {
    return (
      <div className={`modal1 ${isOpen ? "open" : ""}`}>
        <div className="modal1-overlay" onClick={onClose}></div>
        <div className="modal1-content">
          {!isBidDeleted ? (
            <>
              <p>Bidder Name : {currentBidItem?.customerId?.username}</p>
              <p>Bid Amount : ${currentBidItem?.bidAmount}</p>
              <p>
                Bid Date : {convertIsoToCustomFormat(currentBidItem?.bidTime)}
              </p>
              <p>Are you sure you want to delete?</p>

              <div className="button-container">
                <button className="cancel-button" onClick={onClose}>
                  Cancel
                </button>
                <button className="delete-button" onClick={onDelete}>
                  Delete
                </button>
              </div>
            </>
          ) : (
            <div className="alert alert-success" role="alert">
              Bid Deleted Successfully!
            </div>
          )}
        </div>
      </div>
    );
  };

  //console.log("bidHistory", bidHistory);
  const handleDelete = (bidItem) => {
    setOrderIdToDelete(bidItem._id);
    setCurrentBidItem(bidItem);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setOrderIdToDelete(null);
    setCurrentBidItem(null);
    setIsModalOpen(false);
  };
  return (
    <>
      {productId ? (
        <div className="card card-default">
          <div className="card-header">
            <h3 className="card-title">
              <b>Bid History</b>
            </h3>
            <div className="card-tools">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="collapse"
                data-toggle="tooltip"
                title="Collapse"
              >
                <i className="fas fa-minus" />
              </button>
            </div>
          </div>
          <div className="card-body ">
            <div className="row">
              <div className="col-12">
                <CountdownTimer
                  startDate={bidHistory?.bidStartDate}
                  endDate={bidHistory?.bidEndDate}
                />

                {bidHistory?.isRelisted ? (
                  <p>
                    Auction has been relisted on:&nbsp;
                    <b>{convertIsoToCustomFormat(bidHistory?.relistedDate)}</b>
                  </p>
                ) : (
                  <p>
                    Auction has been listed on:&nbsp;
                    <b>{convertIsoToCustomFormat(bidHistory?.bidStartDate)}</b>
                  </p>
                )}

                {bidHistory?.bidList?.length > 0 ? (
                  <>
                    <p>
                      Highest bidder was:&nbsp;
                      <b>{bidHistory?.bidList?.[0]?.customerId?.username}</b>
                    </p>

                    <p>
                      Highest bid was:
                      <b> ${bidHistory?.bidList?.[0]?.bidAmount}</b>
                    </p>
                  </>
                ) : (
                  <p>No bids placed yet</p>
                )}

                <br></br>
                <div className="table-responsive p-0">
                  <table className="table table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>Bidder Name</th>
                        <th>Bidding Time </th>
                        <th>Bid</th>
                        <th style={{ "text-align": "center" }}>Status</th>
                        <th style={{ "text-align": "center" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bidHistory?.bidList?.map((bidItem) => {
                        return (
                          <>
                            <tr>
                              <td>{bidItem?.customerId?.username}</td>
                              <td>
                                {" "}
                                {convertIsoToCustomFormat(bidItem?.bidTime)}
                              </td>

                              <td>${bidItem?.bidAmount}</td>
                              <td>
                                <div
                                  className={`${
                                    bidItem.isWinner &&
                                    bidItem.bidStatus === "completed"
                                      ? "winner"
                                      : !bidItem.isWinner &&
                                        bidItem.bidStatus === "end"
                                      ? "loser"
                                      : "ongoing"
                                  }`}
                                >
                                  <i
                                    className={`fas ${
                                      bidItem.isWinner &&
                                      bidItem.bidStatus === "completed"
                                        ? "fa-check-circle"
                                        : !bidItem.isWinner &&
                                          bidItem.bidStatus === "end"
                                        ? "fa-times-circle"
                                        : "fa-circle"
                                    }`}
                                  />
                                </div>
                              </td>
                              <td style={{ "text-align": "center" }}>
                                <i
                                  className="fa fa-trash"
                                  onClick={() => handleDelete(bidItem)}
                                ></i>
                                <Modal
                                  isOpen={isModalOpen}
                                  onClose={handleCloseModal}
                                  onDelete={handleConfirmDelete}
                                />
                              </td>
                            </tr>
                          </>
                        );
                      })}
                      <tr>
                        <td>Auction Started</td>
                        <td colSpan="3">
                          {" "}
                          {convertIsoToCustomFormat(bidHistory?.bidStartDate)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default ProductBidHistory;
